var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "view-box": "-0.5 -0.5 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: 14,
    width: 14,
    style: {
      marginRight: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.500000000000001 0.13C2.9819291666666667 0.13 0.13 2.9819291666666667 0.13 6.500000000000001C0.13 10.018070833333335 2.9819291666666667 12.870000000000003 6.500000000000001 12.870000000000003C10.018070833333335 12.870000000000003 12.870000000000003 10.018070833333335 12.870000000000003 6.500000000000001C12.870000000000003 2.9819291666666667 10.018070833333335 0.13 6.500000000000001 0.13ZM3.8515208333333337 6.482070833333335C3.6779708333333336 6.308466666666668 3.3965750000000003 6.308466666666668 3.2230250000000003 6.482070833333335C3.0494750000000006 6.655620833333335 3.0494750000000006 6.936962500000001 3.2230250000000003 7.110512500000001L5.000720833333334 8.888208333333335C5.174270833333334 9.061758333333334 5.455666666666667 9.061758333333334 5.629162500000001 8.888208333333335L9.777083333333335 4.740287500000001C9.950633333333334 4.5667375 9.950633333333334 4.2853416666666675 9.777083333333335 4.111791666666667S9.322191666666669 3.9382416666666673 9.148587500000001 4.111791666666667L5.314941666666668 7.945437500000001L3.8515208333333337 6.482070833333335Z",
    fill: "var(--green-500)",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.f152a336e9841f4b4ac9c48756fcf97b.svg";
export { ForwardRef as ReactComponent };